module.exports = __webpack_public_path__ + "img/jacklyn_siu_yuin_tan.95b0e8a7.jpg";